import { ab, logTimeChange } from "../Exam";


export function addTimes(config, times, startTime){
    if (toShowTimeAnalysis()){
        logTimeChange();
        config.data.times = times;
        config.data.used_time = calcTotalTime(startTime);
    }
    return config;
}

export function toShowTimeAnalysis(){
    return parseInt($(ab).attr('data-zeiten')) == 1;
}

export function calcTotalTime(startTime:Date){
    const duration = new Date() - startTime;
    return duration;
}